/*
 * WARNING: THIS IS AN AUTOGENERATED-FILE. DO NOT MANUALLY EDIT THIS FILE.
 *
 * MODIFY FLAGS DATA IN lib/gating.rb AND RUN `bundle exec bin/generate-ts-constants`
 * TO REGENERATE THIS FILE.
 */

export enum Feature {
  ProdEnvironmentIndicator = "ProdEnvironmentIndicator",
  DeveloperMode = "DeveloperMode",
  ColumnHooks = "ColumnHooks",
  EventHooks = "EventHooks",
  AllowRemoveLogo = "AllowRemoveLogo",
  AdvancedBranding = "AdvancedBranding",
  I18N = "I18N",
  HideImportActivityPreview = "HideImportActivityPreview",
  CustomColumns = "CustomColumns",
  ValidationWebhooks = "ValidationWebhooks",
  Headless = "Headless",
  HeadlessValidation = "HeadlessValidation",
  DynamicTemplates = "DynamicTemplates",
  AuditLogs = "AuditLogs",
  ExtendedMetadataWebhookTimeout = "ExtendedMetadataWebhookTimeout",
  AdvancedMappings = "AdvancedMappings",
  CustomEnvironments = "CustomEnvironments",
  CodeHooksV1 = "CodeHooksV1",
  Customizations = "Customizations",
  CustomizationCustomStylesheet = "CustomizationCustomStylesheet",
  Integrations = "Integrations",
  TestMaskDataHighlighting = "TestMaskDataHighlighting",
  InAppBilling = "InAppBilling",
  ValidationWebhooksUnmappedCols = "ValidationWebhooksUnmappedCols",
  TemplateColumnsOrder = "TemplateColumnsOrder",
  ListGridSortOptions = "ListGridSortOptions",
  LockColumns = "LockColumns",
  DashboardImporter = "DashboardImporter",
  UserRoleManagement = "UserRoleManagement",
  FileFeeds = "FileFeeds",
  SelfServeTrial = "SelfServeTrial",
  ServerReachabilityPing = "ServerReachabilityPing",
  DebugTemplatesEndpointLag = "DebugTemplatesEndpointLag",
  EmbeddedPipelineBuilder = "EmbeddedPipelineBuilder",
  DisableDateAutoFormatting = "DisableDateAutoFormatting",
  SuggestedTransforms = "SuggestedTransforms",
  PipelineStepRunPostMappingHooks = "PipelineStepRunPostMappingHooks",
  MalwareFileScan = "MalwareFileScan",
  ShowApiTemplateHooks = "ShowApiTemplateHooks",
  BulkTargetAttributeUpdate = "BulkTargetAttributeUpdate",
  TemplateJsonHooksField = "TemplateJsonHooksField",
  FileFeedsSavedMappings = "FileFeedsSavedMappings",
  MultiUseSftpPath = "MultiUseSftpPath",
  FileFeedIngestionHooks = "FileFeedIngestionHooks",
  RowUniquenessValidation = "RowUniquenessValidation",
  PosthogDisabled = "PosthogDisabled",
  WorkspacesV1 = "WorkspacesV1",
  Workflows = "Workflows",
  RelationalValidations = "RelationalValidations",
  LegacyForbiddenErrorCode = "LegacyForbiddenErrorCode",
  FileFeedWarningsTriggerPartialImport = "FileFeedWarningsTriggerPartialImport",
  DebugEntities = "DebugEntities",
  LegacyValidationHooksAuthType = "LegacyValidationHooksAuthType",
  AiFeatures = "AiFeatures",
  ParallelValidationCodeHooks = "ParallelValidationCodeHooks",
  WorkflowsPdfExtraction = "WorkflowsPdfExtraction",
  WorkspacesExternalCollaborators = "WorkspacesExternalCollaborators",
  WorkflowsAiClassifyValues = "WorkflowsAiClassifyValues",
  WorkflowsAiClassifyPython = "WorkflowsAiClassifyPython",
  WorkflowsPdfExtractionPython = "WorkflowsPdfExtractionPython",
  WorkflowsPdfContentSplit = "WorkflowsPdfContentSplit",
  EmailLoginWithSso = "EmailLoginWithSso",
  DisableEmailLogin = "DisableEmailLogin",
  FixWithAi = "FixWithAi",
  WorkflowsDemo = "WorkflowsDemo",
  InternalApiAuthHeaderAccess = "InternalApiAuthHeaderAccess",
  ExternalAPI = "ExternalAPI",
  WorkflowsCsvAgent = "WorkflowsCsvAgent",
  WorkflowsFileTransformAgent = "WorkflowsFileTransformAgent",
  A11yUserwayWidget = "A11yUserwayWidget",
  WorkflowsNoHeaderDetection = "WorkflowsNoHeaderDetection",
  WorkflowsKeepBlankRows = "WorkflowsKeepBlankRows",
  OrgUsageRecord = "OrgUsageRecord",
  WorkflowsTrackCredits = "WorkflowsTrackCredits",
  EnableGetTemplatesExtApi = "EnableGetTemplatesExtApi",
  ImporterExportParquet = "ImporterExportParquet",
  ImporterEventSnapshots = "ImporterEventSnapshots",
  PauseScheduledDeleteEmbeds = "PauseScheduledDeleteEmbeds",
  WorkflowsSplitList = "WorkflowsSplitList",
  WorkflowsCallWorkflow = "WorkflowsCallWorkflow",
  AiSettings = "AiSettings",
  LargeFileImportTimeout = "LargeFileImportTimeout",
  AvailableLlmProviders = "AvailableLlmProviders",
  AiCodeGeneration = "AiCodeGeneration",
  AiMapping = "AiMapping",
  UsageAndBilling = "UsageAndBilling",
  UseMultipartUpload = "UseMultipartUpload",
  S3MultipartBrowserUpload = "S3MultipartBrowserUpload",
  HuronRoles = "HuronRoles",
  BatchedMappingLookup = "BatchedMappingLookup",
  WorkflowsParallelExecution = "WorkflowsParallelExecution",
  WorkflowsCanvasSidebar = "WorkflowsCanvasSidebar",
  WorkflowsSkipIntermediateCheckpoints = "WorkflowsSkipIntermediateCheckpoints",
  InternalFeatures = "InternalFeatures",
  ConnectionsS3 = "ConnectionsS3",
  WorkflowsGenerateDefaultExports = "WorkflowsGenerateDefaultExports",
  HuronJwt = "HuronJwt",
  WorkflowsPreviewAsPdf = "WorkflowsPreviewAsPdf",
  WorkflowsImportV2 = "WorkflowsImportV2",
  ImportNodeOutputsAsReferences = "ImportNodeOutputsAsReferences",
  PreferCaseSensitivePicklistMatch = "PreferCaseSensitivePicklistMatch",
}

export enum PermanentFeature {
  Importer = "Importer",
  CodeHooksApi = "CodeHooksApi",
  IncreasedCodeHookTimeout = "IncreasedCodeHookTimeout",
}
